import { Typography } from '@mui/material';
import React from 'react';
import styled from 'styled-components';

interface InfoBoxProps {
  icon: React.ReactNode;
  text: string;
  value: string | number;
}

const InfoBoxContainer = styled.div`
  text-align: center;
  margin-right: 16px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  padding: 12px;
  border-radius: 8px;
  min-width: 150px;
`;

const ContentBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const InfoBox: React.FC<InfoBoxProps> = ({ icon, text, value }) => {
  return (
    <InfoBoxContainer>
      <ContentBox>
        {icon}
        <Typography variant="body1" style={{ color: 'white', fontWeight: 'bold', marginLeft: '8px' }}>
          {value}
        </Typography>
      </ContentBox>
      <Typography variant="caption" style={{ color: '#aaa' }}>
        {text}
      </Typography>
    </InfoBoxContainer>
  );
};

export default InfoBox;
